import React from 'react';

function FormationPage() {
  return (
    <div 
      className="formation-page" 
      style={{
        maxWidth: '800px',
        margin: '0 auto',
        padding: '40px 20px',
        color: '#165423',
        backgroundColor: '#eee7df'
      }}
    >
      <h1>🌿 Nos Formations Agricoles</h1>
      <p>
        Découvrez nos programmes de formation professionnelle conçus pour renforcer vos compétences dans les métiers de l’agriculture, alliant savoir-faire traditionnel et techniques modernes.
      </p>
      
      <div className="formation-item" style={{ marginBottom: '30px' }}>
        <h2>🥕 Formation en Récolte des Céréales et Légumes</h2>
        <p>
          Apprenez les meilleures pratiques de cueillette et de récolte pour optimiser vos rendements. 
          Cette formation vous initie aux méthodes manuelles et mécanisées de récolte des produits agricoles 
          tout en respectant les normes de qualité et de sécurité. Idéale pour les saisonniers, agriculteurs ou toute personne souhaitant s'intégrer dans le secteur de la production maraîchère et céréalière.
        </p>
      </div>
      
      <div className="formation-item" style={{ marginBottom: '30px' }}>
        <h2>🌱 Formation en Préparation du Sol</h2>
        <p>
          Une terre bien préparée est la base d’une culture réussie. 
          Cette formation vous permet d’acquérir les compétences nécessaires pour analyser, enrichir et travailler le sol selon les besoins des cultures. 
          Vous apprendrez à manipuler les outils agricoles, choisir les bons amendements, et planifier efficacement vos activités de préparation des terrains agricoles.
        </p>
      </div>
      
      <div className="formation-item" style={{ marginBottom: '30px' }}>
        <h2>🐑 Formation en Élevage des Ovins</h2>
        <p>
          Destinée aux passionnés de l’élevage, cette formation vous accompagne dans toutes les étapes de la gestion d’un troupeau de moutons. 
          De l’alimentation à la reproduction, en passant par la prévention sanitaire et l’entretien des abris, 
          vous développerez une expertise complète pour lancer ou développer une activité d’élevage rentable et durable.
        </p>
      </div>
      
      <p style={{ marginTop: '20px', fontStyle: 'italic' }}>
        📍 Toutes nos formations sont encadrées par des formateurs expérimentés et se déroulent en milieu réel pour favoriser l’apprentissage pratique.
      </p>
    </div>
  );
}

export default FormationPage;
